import React, { Component, useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Card, CardHeader, CardBody, Row, Col, Button, Input, Label, InputGroup, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { getNewsletters, deleteNewsletter, resetNewsletters } from '../../../../store/newsletter/actions'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify'
import { DataTable, ExportCSV, MainLoader, TableRowField } from '../../../../components'
import { selectUserRole } from '../../../../store/user/selector'
import { formatHelper } from '../../../../common/helpers'
import { layout } from '../../../../common/constants'
import MediaQuery from 'react-responsive'

function NewsletterList(props) {
  const
    [page, setPage] = useState(1),
    [filter, setFilter] = useState(''),
    columnOption = {
      dataField: '',
      text: '',
      formatter: optionsFormatterColumn,
      style: { width: '50px' },
      headerStyle: { width: '50px' }
    },
    columns = [
      { dataField: 'title', text: 'Titulo' },
      { dataField: 'short_desc', text: 'Descripción' },
      columnOption
    ],
    columnsSM = [
      {
        dataField: 'xs',
        text: 'Noticia',
        formatter: (cell, row) => <div>
          <TableRowField label='Titulo:' value={row.title} />
        </div>
      },
      columnOption
    ];

  useEffect(() => {
    performGetNewsletters(true)
    return () => {
      props.resetNewsletters()
    }
  }, [])
  useEffect(() => {
    if (props.deletedNewsletter) {
      toast.success('Noticia eliminada satisfactoriamente')
      filterNewsletters()
    } else if (props.deleteError) {
      toast.error(props.deleteNewsletter)
    }
  }, [props.deletedNewsletter])

  function performGetNewsletters(reset = false) {
    props.getNewsletters({ page, filter, reset })
  }

  async function filterNewsletters() {
    await setPage(1)
    performGetNewsletters()
  }

  function handleInputFilterChange(e) {
    if (e.key == 'Enter') filterNewsletters()
  }

  async function handlePageChange(newPage) {
    await setPage(newPage)
    performGetNewsletters()
  }

  function performDeleteNewsletter(id) {
    Swal({
      title: 'Eliminar Noticia',
      text: '¿Estás seguro que deseas eliminar la noticia?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) props.deleteNewsletter(id)
      else if (result.dismiss === Swal.DismissReason.cancel) { }
    })
  }

  function optionsFormatterColumn(cell, row) {
    return <UncontrolledButtonDropdown>
      <DropdownToggle size="sm" color='primary'>
        <i className="fa fa-bars"></i>
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem
          onClick={() => props.history.push(`/administration/newsletters/${row.id}/detail`)}>
          <i className="fa fa-eye mr-1" />
          Detalle
        </DropdownItem>
        <DropdownItem
          onClick={() => props.history.push(`/administration/newsletters/${row.id}/edit`)}>
          <i className="fa fa-edit mr-1" />
          Editar
        </DropdownItem>
        <DropdownItem
          disabled={props.deleteLoading}
          onClick={() => performDeleteNewsletter(row.id)}><i className="fa fa-trash mr-1" />
          Eliminar
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledButtonDropdown>
  }

  return props.loading
    ? <MainLoader />
    : <div className='animated'>
      <Card>
        <CardHeader>
          <i className="icon-list"></i>Noticias
      </CardHeader>
        <CardBody>
          <MediaQuery minDeviceWidth={600}>
            {matches =>
              matches
                ? <Row className='mb-2'>
                  <Col sm="8">
                    <InputGroup>
                      <Input type="text" id="input1-group2" name="input1-group2" placeholder='Buscar'
                        value={filter}
                        onChange={e => setFilter(e.target.value)}
                        onKeyPress={handleInputFilterChange}
                      />
                      <div className="input-group-prepend">
                        <Button type="button" color="primary" onClick={filterNewsletters} ><i className="fa fa-search"></i></Button>
                      </div>
                    </InputGroup>
                  </Col>
                </Row>
                : <Row className='mb-2'>
                  <Col md="10">
                    <InputGroup>
                      <Input type="text" id="input1-group2" name="input1-group2" placeholder='Buscar'
                        value={filter}
                        onChange={e => setFilter(e.target.value)}
                        onKeyPress={handleInputFilterChange}
                      />
                      <div className="input-group-prepend">
                        <Button type="button" color="primary" onClick={filterNewsletters} ><i className="fa fa-search"></i></Button>
                      </div>
                    </InputGroup>
                  </Col>
                </Row>
            }
          </MediaQuery>
          <hr className='my-4' />
          <Row className='mb-2'>
            <Col>
              <div className='float-right'>
                <Button color="primary" onClick={() => props.history.push('/administration/newsletters/add')} ><i className="fa fa-plus mr-1"></i> Nuevo</Button>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <MediaQuery minWidth={layout.SM_MIN_WIDTH} maxWidth={layout.MD_MAX_WIDTH} >
                <DataTable
                  data={props.newsletters}
                  keyField='id'
                  columns={columnsSM}
                  page={page}
                  totalSize={props.total}
                  sizePerPage={props.pageSize}
                  loading={props.loading}
                  onPageChange={handlePageChange}
                />
              </MediaQuery>
              <MediaQuery minWidth={layout.LG_MIN_WIDTH} >
                <DataTable
                  data={props.newsletters}
                  keyField='id'
                  columns={columns}
                  page={page}
                  totalSize={props.total}
                  sizePerPage={props.pageSize}
                  loading={props.loading}
                  onPageChange={handlePageChange}
                />
              </MediaQuery>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
}

function mapStateToProps(state) {
  const { newsletters, error, loading, pageSize, total } = state.newsletter.newsletterList

  return {
    newsletters,
    error,
    loading,
    pageSize,
    total,
    deletedNewsletter: state.newsletter.deleteNewsletter.newsletter,
    deleteError: state.newsletter.deleteNewsletter.error,
    deleteLoading: state.newsletter.deleteNewsletter.loading,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getNewsletters,
    deleteNewsletter,
    resetNewsletters
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(NewsletterList)



// WEBPACK FOOTER //
// ./src/scenes/Administration/Newsletter/NewsletterList/NewsletterList.js